import Box from "ds/components/Box";
import Feedback from "ds/components/Feedback";
import FeedbackActions from "ds/components/Feedback/Actions";
import Link from "ds/components/Link";
import { OpenTofuMigrationWaitingForRunsIssueNode } from "shared/Stack/OpenTofuMigration/gql";
import { pluralizeNext } from "shared/Pluralize";
import { capitalizeFirstLetter } from "utils/strings";
import { OPEN_TOFU_MIGRATION_QUEUE_PATH } from "views/Account/OpenTofuMigration/constants";

type StackSettingsOpenTofuMigrationBlockedCalloutProps = {
  stackId: string;
  isRollback: boolean;
  issue: OpenTofuMigrationWaitingForRunsIssueNode;
};

const StackSettingsOpenTofuMigrationBlockedCallout = ({
  stackId,
  isRollback,
  issue,
}: StackSettingsOpenTofuMigrationBlockedCalloutProps) => {
  const action = isRollback ? "rollback" : "migration";
  const target = isRollback ? "the Terraform vendor" : "the native OpenTofu vendor";
  const hiddenRunsCount = issue.totalCount - issue.runs.length;

  return (
    <Feedback
      type="callout"
      variant="warning"
      title={`${capitalizeFirstLetter(action)} blocked by ${pluralizeNext(issue.totalCount, "run", undefined, "a")}`}
    >
      {`This stack is queued for ${action} to ${target}. The ${action} starts after all blocking runs finish.`}
      <Box gap="small" align="center" margin="medium 0 0 0" wrap>
        Blocked by
        {issue.runs.map((run) => (
          <Link key={run.id} href={`/stack/${stackId}/run/${run.id}`} size="small">
            {run.id}
          </Link>
        ))}
        {hiddenRunsCount > 0 && <span>{`and ${hiddenRunsCount} more`}</span>}
      </Box>
      <FeedbackActions>
        <Link href={OPEN_TOFU_MIGRATION_QUEUE_PATH}>View queue</Link>
      </FeedbackActions>
    </Feedback>
  );
};

export default StackSettingsOpenTofuMigrationBlockedCallout;
